import defaultGameChildComponents from '@/components/game/implementations/_default/_components';
import PotionWinnerListComponent from '@/components/game/implementations/uk/potion/_components/winner-list';
const gameChildComponents = Object.assign({}, defaultGameChildComponents,
{
  potionWinnerList: PotionWinnerListComponent
});
export default gameChildComponents;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/potion/_components/index.ts